export default {
    errorCode: {
        'common': '未知错误码：',
        '-111101': '账号无权限',
        '-111102': '工程名不能重复',
        '-111103': '图纸格式错误',
        '-111104': '图纸重名',
        '-111105': '仿真失败',
        '-111106': '图纸大小超过限制',
        '-111107': '图纸名称长度有误',
        '-111108': '图纸数量超过限制',
        '-111109': '工程正在生成报告',
        '-111110': '工程缺少一些报告的材料',
        '-111111': '坐标超出图纸范围',
        '-111112': '图纸不存在',
        '-111113': '当前频段缺少可仿真的AP',
        '-111114': '障碍物已存在',
        '-111115': '画布设备已存在',
        '-111116': '非法障碍物',
        '-111117': '画布设备非法',
        '-111118': '导出方案报告失败',
        '-111119': '图纸名称过长',
        '-111120': '生成方案失败',
        '-111121': '工程数量超过限制',
        '-111122': '名称包含非法字符',
        '-111123': '画布设备数量超过限制',
        '-111124': '图片分辨率最大不能超过4K'
    }
};
